import dayjs from "dayjs";
import { VN_TO_EN } from "./nhanhExcelFieldMapping";

export const convertExcelOrdersToTargetFormatTC = (excelRows) => {
  const ordersMap = {};
  const ordersOrder = [];

  excelRows.forEach((row) => {
    // Làm sạch key (bỏ khoảng trắng thừa ở tên cột nếu có)
    const cleanRow = {};
    for (const key in row) {
      cleanRow[key.trim()] = row[key];
    }

    // Hàm hỗ trợ format ngày tháng
    const formatDate = (field) => {
      if (cleanRow[field] && typeof cleanRow[field] === "number") {
        const d = new Date(Math.round((cleanRow[field] - 25569) * 86400 * 1000));
        return dayjs(d).format("DD/MM/YYYY");
      }
      return cleanRow[field] !== undefined ? cleanRow[field] : "";
    };

    // Hàm lấy giá trị từ cleanRow theo tên cột tiếng Việt, trả về với key tiếng Anh
    const f = (vnKey) => cleanRow[vnKey] !== undefined ? cleanRow[vnKey] : "";
    const fd = (vnKey) => formatDate(vnKey);

    // Xác định key nhóm theo Số chứng từ (fallback Số Đơn Hàng)
    const orderKey = f("Số chứng từ") || f("Số Đơn Hàng") || "";
    const orderType = cleanRow.orderType || "";

    // Nếu chưa có đơn hàng này, tạo mới với các thông tin header
    if (!ordersMap[orderKey]) {
      ordersMap[orderKey] = {
        [VN_TO_EN["orderType"]]:                         orderType,
        [VN_TO_EN["batCode"]]:                           orderType === "Trả" ? "005" : "004",
        branchID:                                        "HNI",
        branchName:                                      "Công ty Cổ phần Anvy - chi nhánh Hà Nội",
        geCpnyID:                                        "AVM",
        geCpnyName:                                      "CÔNG TY CỔ PHẦN ANVY",
        [VN_TO_EN["Ngày Xuất Hàng"]]:                    fd("Ngày Xuất Hàng"),
        [VN_TO_EN["Số chứng từ"]]:                       f("Số chứng từ"),
        [VN_TO_EN["Số Đơn Hàng"]]:                       f("Số Đơn Hàng"),
        [VN_TO_EN["Ngày đơn hàng"]]:                     fd("Ngày đơn hàng"),
        [VN_TO_EN["Ghi chú"]]:                           f("Ghi chú"),
        [VN_TO_EN["ĐVTT"]]:                              f("ĐVTT"),
        [VN_TO_EN["Mã KH"]]:                             f("Mã KH"),
        [VN_TO_EN["TK nợ"]]:                             f("TK nợ"),
        [VN_TO_EN["TK có"]]:                             f("TK có"),
        [VN_TO_EN["Ngày hóa đơn"]]:                      fd("Ngày hóa đơn"),
        [VN_TO_EN["Số hóa đơn"]]:                        f("Số hóa đơn"),
        [VN_TO_EN["TK GVHB"]]:                           f("TK GVHB"),
        [VN_TO_EN["TK hạch toán"]]:                      f("TK hạch toán"),
        [VN_TO_EN["Giá vốn"]]:                           f("Giá vốn"),
        [VN_TO_EN["[Mảng kinh doanh] Mã"]]:              f("[Mảng kinh doanh] Mã"),
        [VN_TO_EN["Kênh KH"]]:                           f("Kênh KH"),
        [VN_TO_EN["Mã Kho"]]:                            f("Mã Kho"),
        [VN_TO_EN["[Khoản mục Nội bộ] Mã"]]:             f("[Khoản mục Nội bộ] Mã"),
        items: [],
      };
      ordersOrder.push(orderKey);
    }

    // Thêm thông tin sản phẩm vào items[]
    ordersMap[orderKey].items.push({
      [VN_TO_EN["Tên Sản Phẩm"]]:                        f("Tên Sản Phẩm"),
      [VN_TO_EN["[Vật tư hàng hóa] Đvt"]]:               f("[Vật tư hàng hóa] Đvt"),
      [VN_TO_EN["Mã Sản Phẩm"]]:                         f("Mã Sản Phẩm"),
      [VN_TO_EN["Mã Kho"]]:                              f("Mã Kho"),
      [VN_TO_EN["Số Lot"]]:                              f("Số Lot"),
      [VN_TO_EN["Ngày Hết Hạn"]]:                        fd("Ngày Hết Hạn"),
      [VN_TO_EN["Số lượng Lẻ"]]:                         f("Số lượng Lẻ"),
      [VN_TO_EN["Số lượng"]]:                            f("Số lượng"),
      [VN_TO_EN["Đơn giá VND"]]:                         f("Đơn giá VND"),
      [VN_TO_EN["Doanh Số"]]:                            f("Doanh Số"),
      [VN_TO_EN["Thuế suất"]]:                           f("Thuế suất"),
      [VN_TO_EN["TK nợ VAT"]]:                           f("TK nợ VAT"),
      [VN_TO_EN["Tk có VAT"]]:                           f("Tk có VAT"),
      [VN_TO_EN["Thành Tiền Thuế"]]:                     f("Thành Tiền Thuế"),
      [VN_TO_EN["TK Nợ CK"]]:                            f("TK Nợ CK"),
      [VN_TO_EN["TK Có CK"]]:                            f("TK Có CK"),
      [VN_TO_EN["Tổng Tiền CK"]]:                        f("Tổng Tiền CK"),
      [VN_TO_EN["[Khoản mục Nội bộ] Mã"]]:               f("[Khoản mục Nội bộ] Mã"),
      [VN_TO_EN["[Mảng kinh doanh] Mã"]]:                f("[Mảng kinh doanh] Mã"),
    });
  });

  return ordersOrder.map((key) => ordersMap[key]);
};
